import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { PACKAGE_PRESETS, OCCASION_SUGGESTIONS, CATEGORY_ORDER } from './catalog';

const defaultOccasion = 'wedding';

export const useCateringPlannerStore = create(
  persist(
    (set, get) => ({
      selectedIds: [],
      guestCount: 100,
      occasion: defaultOccasion,
      activeCategory: CATEGORY_ORDER[0],
      eventDate: '',
      venue: '',
      mealPreference: 'both',

      setActiveCategory: (cat) => set({ activeCategory: cat }),

      setEventDate: (d) => set({ eventDate: typeof d === 'string' ? d : '' }),

      setVenue: (v) => set({ venue: typeof v === 'string' ? v : '' }),

      setMealPreference: (m) =>
        set({ mealPreference: m === 'veg' || m === 'nonveg' || m === 'both' ? m : 'both' }),

      toggleItem: (id) =>
        set((s) => ({
          selectedIds: s.selectedIds.includes(id)
            ? s.selectedIds.filter((x) => x !== id)
            : [...s.selectedIds, id]
        })),

      isSelected: (id) => get().selectedIds.includes(id),

      clearCart: () => set({ selectedIds: [] }),

      setGuestCount: (n) => {
        const v = Math.max(1, Math.min(50000, Math.floor(Number(n)) || 1));
        set({ guestCount: v });
      },

      setOccasion: (o) => set({ occasion: o || defaultOccasion }),

      /** Replace cart with a package preset */
      applyPackage: (packageKey) => {
        const pkg = PACKAGE_PRESETS[packageKey];
        if (!pkg?.itemIds?.length) return;
        set({ selectedIds: [...pkg.itemIds] });
      },

      /** Merge occasion suggestions into cart */
      applyOccasionSuggestions: () => {
        const { occasion, selectedIds } = get();
        const add = OCCASION_SUGGESTIONS[occasion] || [];
        if (!add.length) return;
        const merged = [...new Set([...selectedIds, ...add])];
        set({ selectedIds: merged });
      },

      /** Hydrate from shared URL payload { s, g, o } */
      hydrateFromShare: (payload) => {
        if (!payload || typeof payload !== 'object') return;
        const ids = Array.isArray(payload.s) ? payload.s.filter((x) => typeof x === 'string') : [];
        const g = Math.max(1, Math.min(50000, Math.floor(Number(payload.g)) || 100));
        const o = typeof payload.o === 'string' ? payload.o : defaultOccasion;
        set({ selectedIds: ids, guestCount: g, occasion: o });
      },

      bumpGuestCount: (delta) => {
        const { guestCount } = get();
        const v = Math.max(1, Math.min(50000, guestCount + delta));
        set({ guestCount: v });
      }
    }),
    {
      name: 'catercraft-planner-v1',
      partialize: (s) => ({
        selectedIds: s.selectedIds,
        guestCount: s.guestCount,
        occasion: s.occasion,
        eventDate: s.eventDate,
        venue: s.venue,
        mealPreference: s.mealPreference
      })
    }
  )
);
